export const LeadCardsViewEnUS = {
  noProject: 'No Leads. Either try again later or update your filters to see more.',
}

export const LeadCardsViewEsMX = {
  noProject: 'No hay Leads. Intenta de nuevo más tarde o actualiza tus filtros para ver más.',
}
